<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <v-row>
        <v-col>
          <p class="headline font-weight-bold" style="color:#AF8936; font-size: 27px !important;">
            Publicación de Sentencias
          </p>
        </v-col>
        <v-col class="mt-5">
          <p style="" align="right" > <b>Num. de Visitas: {{ visitaCount }} </b></p>
        </v-col>
      </v-row>
      <v-divider class="mb-2"></v-divider>
      <!-- 
      ====================================================
        BUTTON "PUBLICAR SENTENCIA (FULL-SCREEN DIALOG)" 
      ====================================================== 
      -->
      <v-row>
        <v-col align="right">
          <template>
            <v-row>
              <v-col align="right">
                <v-dialog
                  v-model="dialog"
                  fullscreen
                  persistent
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="isLoggedIn"
                      tile
                      small
                      color="#AF8936"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>
                        mdi-upload
                      </v-icon>
                      Publicar Sentencia
                    </v-btn>
                  </template>

                  <!-- ******* FORMULARIO PARA NUEVA PUBLICACIÓN ******* -->
                  <v-card>
                    <!-- HEADER_____ NUEVA PUBLICACIÓN -->
                    <v-toolbar
                      dark
                      color="#AF8936"
                    >
                      <v-icon v-if="editedIndex > -1" large>mdi-tooltip-edit</v-icon>
                      <v-icon v-else large>mdi-folder-plus</v-icon>
                      <v-card-title color="#AF8936">
                        <span>{{ formTitle }}</span>
                      </v-card-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        @click.native="close()"
                      >
                        <v-icon>mdi-close</v-icon>Cerrar
                      </v-btn>
                    </v-toolbar>
                    <!-- SELECTS____ MAGISTRADO / SALAS -->
                    <v-container grid-list-md>
                      <v-list-item v-if="currentUser.magistrado_data" class="mt-2 mb-n7">
                        <v-list-item-avatar color="#AF8936">
                          <v-icon dark>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="headline">
                            Sala {{ currentUser.sala_data.id }}<br>
                            {{ currentUser.magistrado_data.nombre }}
                            {{ currentUser.magistrado_data.primer_apellido }}
                            {{ currentUser.magistrado_data.segundo_apellido }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-container>
                    <!-- FORMULARIO -->
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation><br>
                          <v-row v-if="roleUser != 'enlace' ">
                            <v-col cols="12" sm="6" class="mb-n5">
                              <v-select
                                label="Sala"
                                dense
                                outlined
                                v-model="editedItem.sala_id"
                                :items="listSalas"
                                :rules="notBlankRules"
                                prepend-icon="mdi-gavel"
                                item-text="nombre"
                                item-value="id"
                                :readonly="editedIndex > -1"
                                no-data-text="No hay salas"
                                @change="getMaterias()"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" :sm="editedIndex == -1 ? 4 : 6" class="mb-n5">
                              <v-select
                                label="Magistrado"
                                dense
                                outlined
                                v-model="editedItem.magistrado_id"
                                :items="listMagistrados"
                                item-text="ncompleto"
                                item-value="id"
                                :readonly="editedIndex > -1"
                                prepend-icon="mdi-account"
                                no-data-text="No hay magistrados"
                                :disabled="check_magistrado"
                              ></v-select>
                            </v-col>
                            <v-col v-if="editedIndex == -1" cols="12" sm="2" class="mb-n5 mt-n3">
                              <v-checkbox
                                class=""
                                color="#AF8936"
                                v-model="check_magistrado"
                                prepend-icon=""
                                label="Sin Magistrado"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                          <!-- MATERIA / TIPO DE JUICIO -->
                          <v-row>
                            <v-col cols="12" sm="2" class="mb-n5">
                              <v-select
                                label="Materia"
                                dense
                                outlined
                                v-model="editedItem.materia_id"
                                :items="materiasList"
                                :rules="notBlankRules"
                                item-text="nombre"
                                item-value="id"
                                prepend-icon="mdi-blank"
                                no-data-text="No hay Materias En la Sala seleccionada"
                                @blur="clear()"
                                @change="tipoJuicio()"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="10" class="mb-n5">
                              <v-select
                                label="Tipo de Juicio"
                                dense
                                outlined
                                v-model="editedItem.tipo_juicio_id"
                                :items="listTipoJuicios"
                                :rules="notBlankRules"
                                item-text="nombre"
                                item-value="id"
                                :no-data-text="loadingTipoJuicio ? 'Cargando...' : 'No hay tipo de Juicios'"
                                :loading="loadingTipoJuicio"
                                :disabled="validateMateria"
                                @blur="clearAcciones()"
                                prepend-icon="mdi-blank"
                              >
                                <template slot="item" slot-scope="data">
                                  <div class="select-text">
                                    {{ data.item.nombre }}
                                  </div>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                          <!-- TIPO DE SENTENCIA / SENTIDO DE LA SENTENCIA / RESOLUCIÓN EN 2DA INSTANCIA-->
                          <v-row>
                            <v-col cols="6" class="mb-n5">
                              <v-select
                                label="Tipo de Sentencia"
                                dense
                                outlined
                                v-model="editedItem.tipo_sentencia"
                                :items="tipoSentencia"
                                :rules="notBlankRules"
                                item-text="nombre"
                                item-value="id"
                                prepend-icon="mdi-blank"
                                @change="editedItem.resolucion=''"
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="6" class="mb-n5">
                              <v-select
                                label="Sentido de la Sentencia"
                                dense
                                outlined
                                v-model="editedItem.sentido_id"
                                :items="listSentidos"
                                :rules="notBlankRules"
                                item-text="nombre"
                                item-value="id"
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="12" class="mb-n5" v-if="editedItem.tipo_sentencia==2">
                              <v-select
                                label="Resolución en 2da Instancia"
                                dense
                                outlined
                                v-model="editedItem.resolucion"
                                :items="listResoluciones"
                                item-text="nombre"
                                item-value="id"
                                prepend-icon="mdi-blank"
                                clearable
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                          <!-- ACCIÓN O DELITO -->
                          <v-row>
                            <v-col cols="12" class="mb-n5">
                              <v-autocomplete
                                label="Ingrese la Acción o Delito"
                                dense
                                outlined
                                v-model="editedItem.delito_id"
                                :items="listDelitos"
                                :rules="notBlankRules"
                                item-text="nombre"
                                item-value="id"
                                prepend-icon="mdi-blank"
                                :search-input.sync="DelitoInput"
                                no-data-text="No hay Acciones/Delitos"
                                :disabled="validateMateria"
                                clearable
                                @change="getAcciones()"
                              >
                              <template slot="item" slot-scope="data">
                                <div class="select-text">
                                  {{ data.item.nombre }}
                                </div>
                              </template>
                            </v-autocomplete>
                            </v-col>
                          </v-row>
                          <!-- ACCIÓN ESPECÍFICA -->
                          <v-row>
                            <v-col cols="12" class="mb-n5">
                              <v-autocomplete
                                label="Ingrese la Acción Específica"
                                dense
                                outlined
                                v-model="editedItem.accion_especifica_id"
                                :items="listAccionesEspecificas"
                                item-text="nombre"
                                item-value="id"
                                prepend-icon="mdi-blank"
                                no-data-text="No hay Acciones Específicas"
                                :disabled="validateDelitoForm"
                                clearable
                              >
                              <template slot="item" slot-scope="data">
                                <div class="select-text">
                                  {{ data.item.nombre }}
                                </div>
                              </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <!-- ACCIÓN SIMULTÁNEA -->
                          <v-row>
                            <v-col cols="12" class="mb-n5">
                              <v-autocomplete
                                label="Ingrese la Acción Simultánea"
                                dense
                                outlined
                                v-model="editedItem.accion_simultanea_id"
                                :items="listAccionesSimultaneas"
                                item-text="nombre"
                                item-value="id"
                                prepend-icon="mdi-blank"
                                no-data-text="No hay Acciones Simultáneas"
                                :disabled="validateDelitoForm"
                                clearable
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <br>
                          <!-- NUM. TOCA / PERIODO / DERIVADO -->
                          <v-row>
                            <v-col cols="12" sm="5" class="mb-n5">
                              <v-text-field outlined dense v-model="editedItem.numero" label="Número de Toca"
                              prepend-icon="mdi-folder"
                              type="number"
                              min='1'
                              placeholder="1234"
                              :rules="numberRules"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" class="mb-n5">
                              <v-text-field outlined dense
                                v-model="editedItem.periodo"
                                label="Período"
                                type="number"
                                :rules="periodoRules"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" class="mb-n5">
                              <v-text-field outlined dense v-model="editedItem.derivado" label="Derivado"
                                placeholder="A"
                                @input="v => { editedItem.derivado = v.toUpperCase() }"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <!-- FECHAS -->
                          <v-row>
                            <!-- fecha de emisión -->
                            <v-col cols="12" md="6" class="mb-n5">
                              <v-menu
                                ref="dialogDateEmision"
                                v-model="dialogDateEmision"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    :rules="[v => !!v || 'Seleccione Fecha de Emisión de Sentencia']"
                                    v-model="editedItem.fecha_emision"
                                    label="Fecha de Emisión de Sentencia"
                                    prepend-icon="mdi-calendar-outline"
                                    readonly
                                    v-on="on"
                                    dense
                                    outlined
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="editedItem.fecha_emision"
                                  @input="dialogDateEmision = false"
                                  locale="es-mx"
                                  min="2010-01-01"
                                  :max="new Date().toISOString().substr(0, 10)"
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <!-- Fecha publicación -->
                            <v-col cols="12" md="6" class="mb-n5">
                              <v-menu
                                ref="dialogDate"
                                v-model="dialogDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    :rules="[v => !!v || 'Seleccione Fecha de Publicación en Página Web']"
                                    v-model="editedItem.fecha_publicacion"
                                    label="Fecha de Publicación en Página Web"
                                    prepend-icon="mdi-calendar-outline"
                                    readonly
                                    v-on="on"
                                    dense
                                    outlined
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="editedItem.fecha_publicacion"
                                  @input="dialogDate = false"
                                  locale="es-mx"
                                  min="2010-01-01"
                                  :max="new Date().toISOString().substr(0, 10)"
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <!-- UPLOAD FILE -->
                          <v-row v-if="editedIndex == -1">
                            <v-col cols="12" class="mb-n5">
                              <v-file-input
                                v-model="file"
                                color="blue darken-2"
                                counter
                                label="Seleccionar Archivo"
                                multiple
                                prepend-icon="mdi-paperclip"
                                outlined
                                dense
                                show-size
                                accept="application/pdf"
                                :rules="notBlankRules"
                                @change="fileSelected()"
                              ></v-file-input>
                            </v-col>
                          </v-row>
                          <br>
                          <!-- PERSPECTIVAS (GÉNERO/INFANCIA) -->
                          <v-flex v-if="menores == true" class="mt-n5">
                            <v-radio-group
                              row
                              v-model="editedItem.menores"
                              prepend-icon="mdi-human-male-female"
                              label=""
                              :rules="notBlankRules"
                              ><label class="body-1">Niños, Niñas y Adolescentes</label>&nbsp;
                                <v-radio label="SI" value="1" ></v-radio>
                                <v-radio label="NO" value="2"></v-radio>
                            </v-radio-group>
                          </v-flex>
                          <!-- CHECKBOX -->
                          <v-row>
                            <v-col cols="12" sm="6" class="mt-n5">
                              <v-checkbox
                                class="text-genero"
                                color="purple"
                                v-model="editedItem.perspectiva_genero"
                                prepend-icon="mdi-gender-male-female"
                                label="Seleccione si la Sentencia fue Juzgada con Perspectiva de Género"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6" class="mt-n5">
                              <v-checkbox
                                class="text-ninez"
                                color="#2096F3"
                                prepend-icon="mdi-human-child"
                                v-model="editedItem.principio_ninez"
                                label="Seleccione si la Sentencia fue Dictada con Perspectiva de Infancia y Adolescencia"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                          <!-- BUTTONS -->
                          <v-row>
                            <v-col cols="12">
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="red darken-1" outlined @click.native="close">Cancelar</v-btn>
                                <v-btn v-if="editedIndex > -1" color="yellow darken-2" outlined @click.native="editSentencia(editedItem)" :disabled="loading || !valid" :loading="loading">Actualizar</v-btn>
                                <v-btn v-else color="yellow darken-3" outlined @click.native="saveSentencia()" :disabled="loading || !valid" :loading="loading"> Guardar </v-btn>
                              </v-card-actions>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
      <!-- ======================== TITLE "CONSULTA DE SENTENCIAS" ======================== -->
      <v-row class="mt-n7">
        <v-col>
          <p class="title text-center text-uppercase consulta-sentencias">Consulta de Sentencias</p>
        </v-col>
      </v-row>
      <div class="parrafo mt-2">
        <p>
          Ingrese el número de toca a consultar ejemplo: <strong>23-2020</strong>, 
          seleccione la Sala, tipo de Delito/Acción y/o materia
        </p>
      </div>
      <!-- ============================= FILTROS DE BUSQUEDA ============================== -->
       <!-- TIPO DE FECHA / FECHA INICIO / FECHA FINAL -->
      <v-row>
        <v-col sm="4" md="4">
            <v-select
              :items="listFechasSearch"
              v-model="tipo_fecha"
              label="Tipo de Fecha"
              item-value="id"
              item-text="value"
              v-on:change="clear(), disableFecha = false;"
              clearable
              dense
              outlined
            >
            </v-select>
          </v-col>        
        <v-col cols="4" md="4">
          <v-menu
            ref="dialogFecInicio"
            v-model="dialogFecInicio"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_inicio"
                label="Fecha Inicial"
                prepend-inner-icon="mdi-calendar-outline"
                readonly
                v-on="on"
                dense
                clearable
                outlined
                :disabled="disableFecha"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fecha_inicio"
              @input="dialogFecInicio = false"
              locale="es-mx"
              min="2010-01-01"
              :max="new Date().toISOString().substr(0, 10)"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="4" md="4">
          <v-menu
            ref="dialogFecInicio"
            v-model="dialogFecFin"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_fin"
                label="Fecha Final"
                prepend-inner-icon="mdi-calendar-outline"
                readonly
                v-on="on"
                dense
                outlined
                clearable
                :disabled="disableFecha"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fecha_fin"
              @input="dialogFecFin = false"
              locale="es-mx"
              :min="fecha_inicio"
              :max="new Date().toISOString().substr(0, 10)"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <!-- VALIDATE TOCA (NUM.TOCA / SALA / INGRESE MAGISTRADO) -->
      <v-form @submit.prevent="save" ref="search" v-model="validateToca" lazy-validation>
        <v-row>
          <v-col cols="12" sm="3" class="mt-n7">
            <v-text-field
              v-model.trim="number"
              label="Número de Toca"
              clearable
              @blur="clear()"
              :rules="tocaRules"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="5" class="mt-n7">
            <v-select
              :items="listSalas"
              v-model="sala_id"
              label="Sala"
              item-value="id"
              item-text="nombre"
              v-on:change="clear()"
              clearable
              dense
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="4" class="mt-n7">
            <v-select
              :items="listMagistrados"
              v-model="magistrado_id"
              label="Ingrese Magistrado"
              item-value="id"
              item-text="ncompleto"
              clearable
              dense
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
      </v-form>
      <!-- MATERIA / TIPO DE JUICIO -->
      <v-row>
        <v-col cols="12" sm="3" class="mt-n7">
          <v-select
            :items="listMateriasSearch"
            v-model="materia_id"
            label="Materia"
            item-value="id"
            item-text="nombre"
            v-on:change="clear()"
            clearable
            dense
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="9" class="mt-n7">
          <v-select
            label="Tipo de Juicio"
            dense
            outlined
            v-model="tipo_juicio_id"
            :items="listTipoJuicios"
            item-text="nombre"
            item-value="id"
            :no-data-text="loadingTipoJuicio ? 'Cargando...' : 'No hay tipo de Juicios'"
            :loading="loadingTipoJuicio"
            :disabled="searchMateria"
            clearable
          >
          <template slot="item" slot-scope="data">
            <div class="select-text">
              {{ data.item.nombre }}
            </div>
          </template>
          </v-select>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <!-- TIPO DE SENTENCIA / INGRESE SENTIDO DE LA SENTENCIA / RESOLUCIÓN EN 2DA INSTANCIA -->
      <v-row>
        <v-col cols="12" sm="6" class="mt-n7">
          <v-select
            label="Tipo de Sentencia"
            dense
            outlined
            v-model="tipo_sentencia"
            :items="tipoSentencia"
            item-text="nombre"
            item-value="id"
            clearable
            @change="resolucion=''"
          >
        </v-select>
        </v-col>
        <v-col cols="12" sm="6" class="mt-n7">
          <v-select
            :items="listSentidos"
            v-model="sentido_id"
            label="Ingrese Sentido de la Sentencia"
            item-value="id"
            item-text="nombre"
            v-on:change="clear()"
            clearable
            dense
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12" v-if="tipo_sentencia==2" class="mt-n7">
          <v-select
            :items="listResoluciones"
            v-model="resolucion"
            label="Resolución en 2da Instancia"
            item-value="id"
            item-text="nombre"
            v-on:change="clear()"
            clearable
            dense
            outlined
          >
          </v-select>
        </v-col>
      </v-row>
      <!-- INGRESE LA ACCIÓN O DELITO -->
      <v-row class="mt-n7">
        <v-col cols="12">
          <v-autocomplete
            :items="listDelitosAcciones"
            v-model="delito"
            label="Ingrese la Acción o Delito"
            item-text="nombre"
            return-object
            v-on:change="getAcciones()"
            :disabled="searchMateria"
            :search-input.sync="searchInput"
            no-data-text="No hay Coincidencias"
            clearable
            dense
            outlined
          >
          </v-autocomplete>
        </v-col>
        <!-- <v-spacer></v-spacer> -->
      </v-row>
      <!-- INGRESE LA ACCIÓN ESPECÍFICA / INGRESE LA ACCIÓN SIMULTÁNEA -->
      <v-row>
        <v-col cols="12" sm="6" class="mt-n7">
          <v-autocomplete
            :items="listAccionesEspecificas"
            v-model="accion_especifica_id"
            label="Ingrese la Acción Específica"
            item-value="id"
            item-text="nombre"
            no-data-text="No hay Acciones Específicas"
            :disabled="validateDelito"
            clearable
            dense
            outlined
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" class="mt-n7">
          <v-autocomplete
            :items="listAccionesSimultaneas"
            v-model="accion_simultanea_id"
            label="Ingrese la Acción Simultánea"
            item-value="id"
            item-text="nombre"
            no-data-text="No hay Acciones Simultáneas"
            :disabled="validateDelito"
            clearable
            dense
            outlined
          >
        </v-autocomplete>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <!-- BUSCAR POR PALABRA CLAVE -->
      <v-row>
        <v-col cols="12" sm="12" class="mt-n7">
          <v-text-field
            v-model="palabra_clave"
            label="Buscar por Palabra Clave"
            dense
            outlined
            :rules="PalabraClaveRules"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- PERSPECTIVA DE GÉNERO / PERSPECTIVA DE INFANCIA Y ADOLESCENCIA -->
      <v-row>
        <v-col cols="12" sm="6" class="mt-n7">
          <v-checkbox
            class="text-genero"
            color="purple"
            v-model="perspectiva_genero"
            prepend-icon="mdi-gender-male-female"
            label="Seleccione si la Sentencia fue Juzgada con Perspectiva de Género"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="mt-n7">
          <v-checkbox
            class="text-ninez"
            color="#2096F3"
            prepend-icon="mdi-human-child"
            v-model="principio_ninez"
            label="Seleccione si la Sentencia fue Dictada con Perspectiva de Infancia y Adolescencia"
          ></v-checkbox>
        </v-col>
      </v-row>
      <!-- BUTTONS "NUEVA BÚSQUEDA / BUSCAR" -->
      <v-row class="mt-n7">
        <v-spacer></v-spacer>
        <v-col cols="12" md="2">
          <v-btn
            block
            tile
            color="#616161"
            @click.native="cleanBuscar()"
            class="white--text"
            small
            >
            Nueva Búsqueda
          </v-btn>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
            block
            tile
            color="#AF8936"
            @click.native="pagination.current = 1; buscar(); scroll()"
            :disabled="!validateToca || !validatePalabraClave"
            class="white--text"
            small
            >
            <v-icon>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      <!-- ============== TITLE "RESULTADOS DE LA CONSULTA Y TOTAL TOCAS" ============== -->
      <v-row>
        <v-col class="scroll-to-me" ref="tableTop">
          <h4 class="overline">Resultados de la consulta</h4>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="3" class="text-right">
          <div class="flex-grow-1" :style="{ color: `#AF8936` }">
            <h4 v-if="roleUser == 'enlace' && this.currentUser.sala_data.id == totalSala">
              Total tocas sala {{ this.currentUser.sala_data.id }}: {{ tocasTotal.toLocaleString('es-MX') }}
            </h4>
            <h4> Total tocas: {{ this.totalTocasAdmin.toLocaleString('es-MX') }}</h4>
          </div>
        </v-col>
      </v-row>
      <!-- ========= TITLE "AL COLOCAR EL PUNTERO... / RESULTADOS POR PAGINAR" ========= -->
      <v-row>
        <v-col cols="12" md="10">
          <h4 class="d-none overline">Al colocar el  puntero sobre los datos de las columnas se mostrará la información completa.</h4>
        </v-col>
        <v-col class="mt-n1" cols="12" md="2">
          <v-select
            :items="cantidad"
            v-model="paginador"
            item-text="value"
            item-value="value"
            label="Resultados por página"
            v-on:change="paginar()"
            dense
            outlined
          >
          </v-select>
        </v-col>
      </v-row>
      <!-- 
      ================================ 
        TABLA DE TOCAS (RESULTADOS) 
      ================================== 
      -->
      <v-row>
        <v-col cols="12">
        <!-- <v-col cols="12" :style="{ position: `relative` }"> -->
          <!-- WATERMARK/BACKGROUND IMAGE -->
          <!-- <div :style="backgroundImageStyle" class="watermark-background"></div> -->
          <!-- LOADING SPINNER -->
          <div v-if="loadingTocas" class="text-center" :style="{ margin: `0 100px` }">
            <v-progress-circular v-if="loadingTocas"
                size="70"
                :width="7"
                color="#E0A238"
                indeterminate
            ></v-progress-circular>
          </div>
          <!-- BUTTONS "PAGINACION ARRIBA" -->
          <div v-if="!loadingTocas && pagination.total > 1" class="d-flex justify-center align-center pb-4">
            <v-card
              elevation="2"
              hover
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              :disabled="pagination.current <= 1"
              @click="prevPage()"
              aria-label="Anterior"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-card>
            <v-card
              v-if="visiblePages.length && visiblePages[0] > 1"
              elevation="2"
              hover
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              @click="goToPage(1)"
            >
              1
            </v-card>
            <span v-if="visiblePages.length && visiblePages[0] > 2" class="mx-2">...</span>
            <v-card
              v-for="page in visiblePages"
              :key="'top-' + page"
              elevation="2"
              hover
              :color="page === pagination.current ? '#AF8936' : ''"
              :dark="page === pagination.current"
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              @click="goToPage(page)"
            >
              {{ page }}
            </v-card>
            <v-card
              elevation="2"
              hover
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              :disabled="pagination.current >= pagination.total"
              @click="nextPage()"
              aria-label="Siguiente"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-card>
          </div>
          <v-simple-table v-if="!loadingTocas" class="content-container">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="d-none">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, id) in listTocas" :key="id">
                  <td class="px-0" :style="{ fontSize: `13px !important` }">
                    <v-container>
                      <v-row no-gutters>
                        <!-- col 1 -->
                        <v-col cols="12" lg="4" md="8" sm="12" class="pr-1">
                          <div v-if="item.derivado">
                            <span class="font-weight-black">Toca: </span>
                            <span class="font-weight-bold">{{ item.numero }}-{{ item.periodo }}-{{ item.derivado }}</span>
                          </div>
                          <div v-else>
                            <span class="font-weight-black">Toca: </span>
                            <span class="font-weight-bold">{{ item.numero }}-{{ item.periodo}}</span>
                          </div>
                          <div>
                            <span class="font-weight-medium">Sala: </span>{{ item.salas_data.nombre }}
                          </div>
                          <div>
                            <span class="font-weight-medium">Ponencia:</span> 
                            {{ item.magistrado_data && item.magistrado_data.nombre ? item.magistrado_data.nombre : '' }} 
                            {{ item.magistrado_data && item.magistrado_data.primer_apellido ? item.magistrado_data.primer_apellido : '' }} 
                            {{ item.magistrado_data && item.magistrado_data.segundo_apellido ? item.magistrado_data.segundo_apellido : ''}}
                          </div>
                          <div>
                            <span class="font-weight-medium">Materia:</span> 
                            {{ item.materia_data && item.materia_data.nombre ? item.materia_data.nombre : '' }}
                          </div>
                          <div>
                            <b class="font-weight-medium">Tipo de Juicio:</b> 
                            {{ item.tipo_juicio_data && item.tipo_juicio_data.nombre ? item.tipo_juicio_data.nombre : '' }}
                          </div>
                        </v-col>
                        <!-- col 2 -->
                        <v-col cols="12" lg="4" sm="12">
                          <div>
                            <span class="font-weight-medium">Tipo de Sentencia:</span>
                            {{ item.tipo_sentencia && item.tipo_sentencia === 1
                              ? "Interlocutoria"
                              : item.tipo_sentencia && item.tipo_sentencia === 2
                              ? "Definitiva" 
                              : '' }}
                          </div>
                          <div class="pb-2">
                            <span class="font-weight-medium">Sentido de la Sentencia:</span>
                            {{ item.sentido_data && item.sentido_data.nombre ? item.sentido_data.nombre : '' }}
                          </div>
                          <div v-if="item.perspectiva_genero === 1 || item.principio_ninez === 1">
                            <p v-if="item.perspectiva_genero === 1" class="my-0" :style="{color: 'purple'}">
                              <span class="mdi mdi-gender-male-female x-small"></span>
                              <b>La sentencia fue juzgada con Perspectiva de Género.</b>
                            </p>
                            <p v-if="item.principio_ninez === 1" class="my-0" :style="{color: '#2096F3'}">
                              <span class="mdi mdi-human-child x-small"></span>
                              <b>La sentencia fue dictada con Perspectiva de Infancia y Adolescencia.</b>
                            </p>
                          </div>
                        </v-col>
                        <!-- col 3 -->
                        <v-col cols="12" lg="4" md="8" sm="10">
                          <div v-if="isLoggedIn">
                            <span class="font-weight-medium">Url descarga:</span>&nbsp; 
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  x-small
                                  v-on="on"
                                  v-bind="attrs"
                                  class="mr-1"
                                  @click="copyURL(item)"
                                >
                                  <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                              </template>
                              <span>Copiar URL</span>
                            </v-tooltip>
                            {{ item.id }}
                          </div>
                          <div v-if="isLoggedIn">
                            <span class="font-weight-medium">Fecha Emisión de Sentencia:</span>
                            {{ item.fecha_emision | formatDate }}
                          </div>
                          <div>
                            <span class="font-weight-medium">Fecha Publicación en Página Web:</span>
                            {{ item.fecha_publicacion | formatDate }}
                          </div>
                        </v-col>
                      </v-row>
                      <!-- ACCION ESPECÍFICA, SIMULTÁNEA Y ACTIONS -->
                      <v-row no-gutters class="justify-space-between">
                        <v-col cols="12">
                          <div>
                            <span class="font-weight-medium">Delito / Acción: </span>
                            {{ item.delito_data && item.delito_data.nombre ? item.delito_data.nombre : '' }}
                          </div>
                        </v-col>
                        <v-col cols="12" lg="8" sm="10" xs="10">
                          <div v-if="item.accion_especifica_data && item.accion_especifica_data.nombre">
                            <span class="font-weight-medium">Acción Específica: </span>
                            {{ item.accion_especifica_data.nombre }}
                          </div>
                          <div v-if="item.accion_simultanea_data && item.accion_simultanea_data.nombre">
                            <span class="font-weight-medium">Acción Simultánea:</span> 
                            {{ item.accion_simultanea_data.nombre }}
                          </div>
                        </v-col>
                        <!-- <div class="float-left mt-2">
                          <v-btn top v-if="item.status_resumen_ia"
                              x-small
                              color="#000080"
                              dark
                              class="float-left"
                              @click="getFileTXT(item, 'visualizar')"
                            >
                              Resumen de Sentencia Ciudadana
                            </v-btn>
                        </div> -->
                        <!-- ACTIONS -->
                        <v-col cols="12" lg="4" sm="4" xs="4">
                          <div>
                            <!-- DESCARGAR -->
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  small
                                  dark
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="#616161"
                                  @click="getFile(item, 'descargar')"
                                >
                                  <v-icon>mdi-file-download</v-icon>
                                </v-btn>
                              </template>
                              <span>Descargar</span>
                            </v-tooltip>
                            <!-- MOSTRAR ARCHIVO PDF -->
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  small
                                  dark
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="#1876D1"
                                  @click="getFile(item, 'visualizar')"
                                >
                                  <v-icon>mdi-file-find-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Ver en línea</span>
                            </v-tooltip>
                            <!-- MOSTRAR ARCHIVO TXT -->
                            <v-btn top v-if="item.url_resumen_ia"
                              x-small
                              color="#1876D1"
                              dark
                              class="float-left mt-1"
                              @click="getFileTXT(item, 'visualizar')"
                            >
                              Resumen Ciudadano
                            </v-btn>
                            <!-- <v-tooltip top v-if="item.status_resumen_ia">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  small
                                  dark
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="rgb(175, 137, 54)"
                                  @click="getFileTXT(item, 'visualizar')"
                                >
                                  <v-icon>mdi mdi-file-cog</v-icon>
                                </v-btn>
                              </template>
                              <span>Resumen Sentencia Ciudadana</span>
                            </v-tooltip> -->
                            <!-- EDITAR -->
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-if="(roleUser == 'superadmin' || roleUser == 'admin')  || ( (isLoggedIn) && ( currentUser.magistrado_data.id == item.magistrado_id ) && (currentUser.sala_data.id == item.sala_id) )"
                                  icon
                                  small
                                  dark
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="orange"
                                  @click="editItem(item)"
                                >
                                  <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                              </template>
                              <span>Editar</span>
                            </v-tooltip>
                            <!-- ELIMINAR -->
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="(roleUser == 'superadmin' || roleUser == 'admin')  || ( (isLoggedIn) && ( currentUser.magistrado_data.id == item.magistrado_id ) && (currentUser.sala_data.id == item.sala_id) )"
                                  icon
                                  small
                                  dark
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="#F44336"
                                  @click="deleteSentencia(item)"
                                >
                                  <v-icon>
                                    mdi-delete-forever
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>Eliminar</span>
                            </v-tooltip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <!-- <div>
                      <b>Url Descarga:</b>
                      {{ item.id }}
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mr-1"
                            x-small
                            icon
                            @click="copyURL(item.url)"
                          >
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-content-copy
                            </v-icon>
                          </v-btn>
                        </template>

                        <span>Copiar URL</span>
                      </v-tooltip>
                    </div> -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- BUTTONS "PAGINACION" -->
          <div v-if="pagination.total > 1" class="d-flex justify-center align-center pt-10">
            <v-card
              elevation="2"
              hover
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              :disabled="pagination.current <= 1"
              @click="prevPage()"
              aria-label="Anterior"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-card>
            <v-card
              v-if="visiblePages.length && visiblePages[0] > 1"
              elevation="2"
              hover
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              @click="goToPage(1)"
            >
              1
            </v-card>
            <span v-if="visiblePages.length && visiblePages[0] > 2" class="mx-2">...</span>
            <v-card
              v-for="page in visiblePages"
              :key="page"
              elevation="2"
              hover
              :color="page === pagination.current ? '#AF8936' : ''"
              :dark="page === pagination.current"
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              @click="goToPage(page)"
            >
              {{ page }}
            </v-card>
            <v-card
              elevation="2"
              hover
              height="34"
              min-width="34"
              class="d-flex mx-2 pa-0 justify-center align-center"
              :disabled="pagination.current >= pagination.total"
              @click="nextPage()"
              aria-label="Siguiente"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <v-dialog
        v-model="progressFileTXT"
        hide-overlay
        persistent
        width="500"
      >
        <v-card class="text-center">
          <v-card-subtitle class="pt-5">
            <b>Generando Resumen Ciudadano</b>
          </v-card-subtitle>
          <v-card-text>
            <v-progress-circular
              :size="100"
              :width="15"
              :value="value"
              color="rgb(175, 137, 54)"
              class="mt-3"
              :inderteminate="false"
            >
              <img src="@/assets/Escudo-logo.svg" width="30" height="30" />
              <!-- {{ value }} -->
            </v-progress-circular>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="progress"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="grey darken-2"
          dark
        >
          <v-card-text>
            Cargando Archivo
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogCopy"
        hide-overlay
        persistent
        width="150"
      >
        <v-card
          color="green"
          dark
        >
          <v-card-text class="mb-n5">
            <b class="ml-3 font-weight-black">Url copiada</b>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- modal con contenido TXT -->
      <v-dialog v-model="dialogFileTXT">
        <v-card class="pa-4 full-screen-card">
          <v-card-title class="headline justify-center">
            <img src="@/assets/Escudo-logo.svg" width="30" height="30" />
            <span class="pl-5">Resumen Ciudadano</span>
          </v-card-title>
          <v-divider class="pb-5"></v-divider>
          <v-card-text class="text-container full-screen-content">
            {{ fileContentTXT }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogFileTXT = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- modal con visor PDF embebido -->
      <v-dialog v-model="dialogPDF" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="#415364" dense flat>
            <v-icon left>mdi-file-pdf-box</v-icon>
            <v-toolbar-title>Visor de Sentencia</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small dark text @click="dialogPDF = false; pdfUrl = ''">
              <v-icon left small>mdi-close</v-icon>
              Cerrar documento
            </v-btn>
          </v-toolbar>
          <v-progress-linear
            v-if="pdfUrl && !pdfLoaded"
            indeterminate
            color="#415364"
          ></v-progress-linear>
          <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            @load="pdfLoaded = true"
            style="width: 100%; height: calc(100vh - 48px); border: none;"
          ></iframe>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>

import { mapGetters } from 'vuex';

const Swal = require('sweetalert2');

export default {
  data: () => ({
    path: process.env.VUE_APP_PATH_DOWNLOAD,
    dialogDate: false,
    dialogDateEmision: false,
    dialogCopy: false,
    dialogFecInicio: false,
    dialogFecFin: false,
    dialogFileTXT: false,
    dialogPDF: false,
    pdfUrl: '',
    pdfLoaded: false,
    tipo_fecha: '',
    fecha_inicio: '',
    fecha_fin: '',
    searchInput: '',
    DelitoInput: '',
    materiasList: [],
    listTipoJuicios: [],
    loadingTipoJuicio: false,
    listDelitos: [],
    listDelitosAcciones: [],
    listAccionesEspecificas: [],
    listAccionesSimultaneas: [],
    listMaterias: [],
    listMateriasSearch: [],
    searchMateria: true,
    disableFecha: true,
    validateMateria: true,
    validateDelito: true,
    validateDelitoForm: true,
    valid: true,
    validateToca: true,
    validatePalabraClave: true,
    value: 0, // propiedad/valor para medicion de intervalo "Spinner TXT"
    check_magistrado: false,
    flag_sala: true,
    menores: false,
    totalSala: '',
    number: '',
    sala_id: '',
    numero: '',
    derivado: '',
    delito_id: '',
    materia_id: '',
    tipo_juicio_id: '',
    delito: '',
    periodo: '',
    accion_especifica_id: '',
    accion_simultanea_id: '',
    perspectiva_genero: false,
    principio_ninez: false,
    magistrado_id: '',
    sentido_id: '',
    tipo_sentencia: '',
    resolucion: '',
    tipo_juicio_id: '',
    palabra_clave: '',
    hora_emision: '',
    hora_publicacion: '',
    visitaCount: '',
    pagination: {
      current: 1,
      total: 0
    },
    scrollToList: false,
    per_page_table:20,
    paginador:10,
    // paginador:20,
    cantidad: [
      { id: 1, value: 10 },
      { id: 2, value: 20 },
      { id: 3, value: 30 },
      { id: 4, value: 40 },
      { id: 5, value: 50 }
    ],
    interval: null,
    TocasList: [],
    totalTocasAdmin: '',
    dialog: false,
    progress: false,
    progressFileTXT: false,
    loading: false,
    loadingTocas: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 40,
    file: [],
    files: [],
    fileContentTXT: "",
    archivo: {
      encode:'',
    },
    listFechasSearch:[ 
      { id:'emision', value: 'Fecha Emisión de Sentencia' },
      { id:'publicacion', value: 'Fecha Publicación en Página Web' },
    ],
    tocaRules: [
      v => /^(\d+)(\-)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato válido',
    ],
    PalabraClaveRules: [
      v => !v || /^(([^a-zñA-ZÑ]*[A-ZÑa-zñ]){4})/.test(v) || 'Ingrese una palabra clave que contenga al menos 4 caracteres',
    ],
    visita: {
      // fecha: new Date().toISOString().substr(0, 10), "substr" <--________ YA ESTA EN DESUSO 
      fecha: new Date().toISOString().slice(0, 10),
      path: window.location.pathname,
      device: navigator.userAgent,
    },
    editedItem: {
      sala_id:'',
      magistrado_id:'',
      materia_id:'',
      tipo_juicio_id:'',
      delito_id:'',
      accion_especifica_id:'',
      accion_simultanea_id:'',
      numero:'',
      periodo: new Date().getFullYear(),
      derivado:'',
      fecha_emision:'',
      fecha_publicacion:'',
      file:'',
      perspectiva_genero: false,
      principio_ninez: false,
      menores: '',
      tipo_sentencia: '',
      resolucion: '',
      sentido_id: ''
    },
    defaultItem: {
      sala_id:'',
      magitrado_id:'',
      materia_id:'',
      tipo_juicio_id:'',
      delito_id:'',
      accion_especifica_id:'',
      accion_simultanea_id:'',
      numero:'',
      periodo: new Date().getFullYear(),
      derivado:'',
      fecha_emision:'',
      fecha_publicacion:'',
      file:'',
      perspectiva_genero: false,
      principio_ninez: false,
      menores: '',
      tipo_sentencia: '',
      resolucion: '',
      sentido_id: ''
    },
    tipoSentencia: [
      { id: 1, nombre: 'Interlocutoria'},
      { id: 2, nombre: 'Definitiva' }
    ],
    listResoluciones:[
      { id: 1, nombre: 'Condenatoria' },
      { id: 2, nombre: 'Absolutoria' }
    ],
    listSentidos: [],
    editedIndex: -1,
    notBlankRules: [v => !!v || 'Este campo es requerido'],
    numberRules: [
      v => !!v || 'Este campo es requerido',
      v => /^([1-9][0-9]*)*$/.test(v)  || 'El Toca no debe iniciar con cero',
    ],
    periodoRules:[
      v => ( v >= 1900 ) || 'El año no puede ser menor  al año 1900',
      v => ( v <= new Date().getFullYear() ) || 'El año no puede ser mayor al año actual',
    ],
  }),
  computed:{
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Publicación' : 'Editar Publicación'
    },
    // backgroundImageStyle() {
    //   const imageUrl = require('@/assets/Logo_stj.png'); 
    //   return {backgroundImage: `url(${imageUrl})`};
    // },
    ...mapGetters([
      "listTocas",
      "tocasTotal",
      "listSalas",
      "roleUser",
      "isLoggedIn",
      "currentUser",
      "listMagistrados",
    ]),
    visiblePages() {
      var total = this.pagination.total || 0;
      var current = this.pagination.current || 1;
      if (total <= 5) {
        var all = [];
        for (var i = 1; i <= total; i++) all.push(i);
        return all;
      }
      if (current <= 5) return [1, 2, 3, 4, 5];
      return [current - 4, current - 3, current - 2, current - 1, current];
    },
  },
  watch: {
    number: function (val) {
      this.pagination.current = 1;
      if(!val){
        this.number = '',
        this.validateToca = true;
        this.buscar()
        return this.$refs.search.resetValidation()
      }
    },
    sala_id (val){
      this.pagination.current = 1;
      this.filterMateriasPublic(val);
      if(!val){
        this.listMateriasSearch = this.listMaterias
        this.materia_id = ''
        this.number = ''
        this.sala_id = ''
        this.accion_especifica_id = ''
        this.accion_simultanea_id = ''
        this.validateToca = true;
        return this.$refs.search.resetValidation()
      }
    },
    delito_id (val){
      this.pagination.current = 1;
      if(!val){
        this.number = '',
        this.validateToca = true;
        return this.$refs.search.resetValidation()
      }
    },
    delito (val){
      this.pagination.current = 1;
      this.validateDelito = false;
      if(!val){
        this.validateDelito = true;
        this.accion_especifica_id = ''
        this.accion_simultanea_id = ''
      }
    },
    materia_id (val){
      this.pagination.current = 1;
      // this.sala_id = '';
      this.searchMateria = false;
      this.getDelitos();
      if(!val){
        // this.number = '',
        this.tipo_juicio_id = '',
        this.delito_id = '',
        this.delito = '',
        this.searchMateria = true;
        this.validateToca = true;
        return this.$refs.search.resetValidation()
      }
    },
    palabra_clave (val){
      this.pagination.current = 1;
      if (val.length > 3) {
        this.validatePalabraClave = true;
      } else {
        this.validatePalabraClave = false;
      }
      if(!val){
        this.validatePalabraClave = true;
        return this.$refs.search.resetValidation()
      }
    },
    'editedItem.materia_id': function (val){
        this.validateMateria = false;
        if(!val){
          this.validateMateria = true;
        }
    },
    'editedItem.delito_id': function (val){
      this.validateDelitoForm = false;
      if(!val){
        this.validateDelitoForm = true;
        this.editedItem.accion_especifica_id = ''
        this.editedItem.accion_simultanea_id = ''
      }
    },
    check_magistrado (val){
      if (val) {
        // this.$refs.form.resetValidation()
        this.editedItem.magistrado_id = 0
      }
      if(!val){
        // this.$refs.form.resetValidation()
        this.editedItem.magistrado_id = ''

      }
    },
    tipo_fecha (val){
      this.pagination.current = 1;
      // this.sala_id = '';
      this.disableFecha = false;
      if(!val){
        // this.number = '',
        this.tipo_fecha = '',
        this.fecha_inicio = '',
        this.fecha_fin = '',
        this.disableFecha = true;
        return this.$refs.search.resetValidation()
      }
    },
    searchInput: function (value) {
      if(value){
        if (value.length > 3) {
          this.getDelitosFilter(value)
        }
        // this.buscar()
      }
      if (!value) {
        // this.buscar()
        this.getDelitos()
      }
    },
    DelitoInput: function (value) {
      if (value === 'VIOLENCIA INTRAFAMILIAR' || value === 'FEMINICIDIO') {
      // if (value.includes('VIOLENCIA INTRAFAMILIAR')) {
        this.menores = true
        // this.editedItem.menores = false
      } else {
        this.menores = false
        this.editedItem.menores = ''
      }
      if (!value) {
        this.menores = false
        this.editedItem.menores = ''
      }
    },
  },
  mounted(){
    this.getMateriasFilter()
    this.getSalas()
    this.getMagistrados()
    this.getSentidos()
    this.buscar()
    this.saveVisita()
  },
  methods:{
    paginar(){
      // Scroll to the top of the table
      if (this.$vuetify.goTo && this.$refs.tableTop) {
        this.$vuetify.goTo(this.$refs.tableTop, {
          duration: 1000, // Adjust duration for smooth scrolling
          offset: 0, // Adjust offset if needed
          easing: 'easeInCubic', // Use any easing function supported by Vuetify
        });
      }
      this.pagination.current = 1;
      this.buscar();
    },
    scroll() {
      const el = this.$el.getElementsByClassName('scroll-to-me')[0];
      el.scrollIntoView({ behavior: 'smooth' })
    },
    filterMateriasPublic(val){
      this.listMateriasSearch = [];
      var materias = this.listMaterias;
      // console.log(materias);
      materias.forEach(materia => {
        if ((val == 1 || val == 2 || val == 6 || val == 10 || val == 11) && (materia.id == 4)) {
            this.listMateriasSearch.push(materia)
            this.materia_id = ''
          }
        if ((val == 3 || val == 4 || val == 5 || val == 7 || val == 8 || val == 9) && (materia.id == 3 || materia.id == 2 || materia.id == 1 || materia.id == 6)) {
            this.listMateriasSearch.push(materia)
            this.materia_id = ''
          }
        });
    },
    cleanBuscar() {
        this.pagination.current = 1;
        this.tipo_fecha = '',
        this.fecha_inicio = '',
        this.fecha_fin = '',
        this.number = '',
        this.materia_id = '',
        this.delito = '',
        this.sala_id = '',
        this.accion_especifica_id = '',
        this.accion_simultanea_id = '',
        this.magistrado_id = '',
        this.sentido_id = '',
        this.tipo_sentencia = '',
        this.resolucion = '',
        this.tipo_juicio_id = '',
        this.palabra_clave = '',
        this.perspectiva_genero = false,
        this.principio_ninez = false,
        //this.disableFecha = true,
        this.$refs.search.resetValidation()
        // this.listMateriasSearch = this.listMaterias;
        this.buscar()
        // this.validateToca = true
    },
    clear() {
      if (!this.number) {
        this.$refs.search.resetValidation()
        this.validateToca = true
      }
      if (this.materia_id) {
        this.tipoJuicio()
      }
      // this.number = ''
    },
    clearAcciones () {
      if (!this.editedItem.tipo_juicio_id) {
        this.editedItem.accion_especifica_id = ''
        this.editedItem.accion_simultanea_id = ''
      }
      if (!this.tipo_juicio_id) {
        this.accion_especifica_id = ''
        this.accion_simultanea_id = ''
      }
      // this.number = ''
    },
    getSalas() {
      if (this.roleUser == 'enlace') {
        this.getMaterias();
      }
      this.loading = true;
      this.$store.dispatch("GET_SALAS",  { url: "/salas" } ).then(response => {
        // console.log(response.data);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getMateriasFilter() {
      this.loading = true;
      this.$store.dispatch("GET_MATERIAS",  { url: "/materias" } ).then(response => {
        this.listMaterias = response.data.data.materias;
        this.listMateriasSearch = response.data.data.materias;
        if (this.roleUser == 'enlace') {
          this.filterMateriasPublic(this.sala_id);
        }
        // console.log(response.data.data.materias);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getMaterias() {
      this.materiasList = [];
      this.listTipoJuicios = [];
      this.listDelitos = [];
      this.editedItem.materia_id = '';
      this.editedItem.tipo_juicio_id = '';
      this.editedItem.delito_id = '';

      // Resetear validaciones si el usuario no es 'enlace'
      if (this.roleUser !== 'enlace' && this.editedIndex === -1) {
        this.$refs.form.resetValidation();
      }

      this.$store.dispatch("GET_MATERIAS", { url: "/materias" })
      .then(response => {
        const materias = response.data.data.materias;
        const salaId = (this.currentUser && this.currentUser.sala_data && this.currentUser.sala_data.id) 
                        ? this.currentUser.sala_data.id // Rol de enlace
                        : this.editedItem.sala_id; // Rol de superadmin

        // Funcion para verificar si una materia es valida segun el rol y sala
        const isValidMateria = (materia) => {
          
          const isSala = ((salaId <= 2 || salaId === 6 || salaId >= 10) && materia.id === 4) ||
                         ((salaId >= 3 && salaId <= 5) || (salaId >= 7 && salaId <= 9)) && 
                         (materia.id <= 3 || materia.id === 6);

          return isSala;
        };

        // Filtrar las materias validas
        this.materiasList = materias.filter(isValidMateria);

      })
      .catch(error => {
        console.error(error);
      });
    },
    tipoJuicio() {
      this.editedItem.accion_especifica_id = ''
      this.editedItem.accion_simultanea_id = ''
      this.editedItem.tipo_juicio_id = ''
      this.editedItem.delito_id = ''
      this.loadingTipoJuicio = true
      var materia_id
      if (this.editedItem.materia_id) {
        materia_id = this.editedItem.materia_id
      } else if(this.materia_id){
        materia_id = this.materia_id
      }
      // this.$refs.form.resetValidation()
      this.$store.dispatch("GET_TIPO_JUICIO",  { url: "/materia/"+materia_id+"/tipo-juicios" } ).then(response => {
        this.listTipoJuicios = response.data.data.tipo_juicios;
        this.listDelitos = response.data.data.delitos;
        this.loadingTipoJuicio = false
      })
      .catch(error => {
        this.loadingTipoJuicio = false
        console.log(error);
      });
    },
    getDelitos() {
      // this.loading = true;
      this.$store.dispatch("GET_DELITOS",  { url: "/delitos-total",
        data: {
          materia_id:this.materia_id,
        }
        }).then(response => {
        this.listDelitosAcciones = response.data.data.delitos;
        // console.log(response.data);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getSentidos() {
      this.$store.dispatch("GET_SENTIDOS_CATALOGO",  { url: "/sentidos-activos",
        }).then(response => {
        this.listSentidos = response.data.data.sentidos;
        // console.log(response.data);
      })
      .catch(error => {
        console.log(error);
      });
    },
    getAcciones(){
      this.getEspecificas()
      this.getSimultaneas()
    },
    getEspecificas() {
      this.editedItem.accion_especifica_id = ''
      this.accion_especifica_id = ''
      var delito_id
      if (this.editedItem.delito_id) {
        delito_id = this.editedItem.delito_id
      } else if(this.delito){
        delito_id = this.delito.id
      }
      this.$store.dispatch("GET_ACCIONES_ESPECIFICAS",  { url: "/delito/"+delito_id+"/acciones-especificas",
        }).then(response => {
          // console.log(response.data.data.acciones_especificas);
        this.listAccionesEspecificas = response.data.data.acciones_especificas;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getSimultaneas() {
      this.editedItem.accion_simultanea_id = ''
      this.accion_simultanea_id = ''
      var delito_id
      if (this.editedItem.delito_id) {
        delito_id = this.editedItem.delito_id
      } else if(this.delito){
        delito_id = this.delito.id
      }
      this.$store.dispatch("GET_ACCIONES_SIMULTANEAS",  { url: "/delito/"+delito_id+"/acciones-simultaneas",
        }).then(response => {
        this.listAccionesSimultaneas = response.data.data.acciones_simultaneas;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getDelitosFilter(value) {
      // this.loading = true;
      this.$store.dispatch("GET_DELITOS",  { url: "/delitos-total",
        data: {
          materia_id:this.materia_id,
          nombre_delito: value
        }
        }).then(response => {
        this.listDelitosAcciones = response.data.data.delitos;
        // console.log(response.data);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getMagistrados() {
      this.loading = true;
      this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" } ).then(response => {
        // console.log(response.data);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getTocasCount() {
      // this.loading = true;
      this.$store.dispatch("GET_TOCAS_COUNT",  { url: "/tocas/sala/"+this.currentUser.sala_data.id+"/count" } ).then(response => {
        // console.log(response.data);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },
    editItem (item) {
      // console.log(item);
      this.editedIndex = this.listTocas.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      this.editedItem.id = item.id
      this.editedItem.sala_id = item.sala_id
      if (item.magistrado_id > 0) {
        this.editedItem.magistrado_id = item.magistrado_id
      }
      this.getMaterias();
      if (item.materia_id > 0) {
        this.editedItem.materia_id = item.materia_id
        this.tipoJuicio();
        this.editedItem.tipo_juicio_id = item.tipo_juicio_id
        this.editedItem.delito_id = item.delito_id
        this.getAcciones();
        this.editedItem.accion_especifica_id = item.accion_especifica_id
        this.editedItem.accion_simultanea_id = item.accion_simultanea_id
      }
      this.editedItem.tipo_sentencia = item.tipo_sentencia
      this.editedItem.resolucion = item.resolucion
      this.editedItem.sentido_id = item.sentido_id
      this.editedItem.numero = item.numero
      this.editedItem.periodo = item.periodo
      this.editedItem.derivado = item.derivado

      var fecha = item.fecha_publicacion.split(" ", 2)
      this.editedItem.fecha_publicacion = fecha[0];
      this.hora_publicacion = fecha[1];

      var fecha = item.fecha_emision.split(" ", 2)
      this.editedItem.fecha_emision = fecha[0];
      this.hora_emision = fecha[1];
      //  var fecha_publicacion = item.fecha_publicacion.split("-",3)
      // this.editedItem.fecha_publicacion = fecha_publicacion[2] + "-" + fecha_publicacion[1] + "-" + fecha_publicacion[0]

      if (item.perspectiva_genero == 1) {
        this.editedItem.perspectiva_genero = true
      }
      if (item.principio_ninez == 1) {
        this.editedItem.principio_ninez = true
      }
      if (item.menores == 1) {
        this.editedItem.menores = "1"
      }
      if (item.menores == 2) {
        this.editedItem.menores = "2"
      }
      // this.editedItem.role = item.roles[0].id
      this.dialog = true
    },
    buscar() {
      this.loadingTocas = true;
      if (this.number) {
        var number = this.number
        number = number.split("-",3)
        this.numero = number[0];
        this.periodo = number[1];
        this.derivado = number[2];
      }  else {
        this.validateToca = true
        this.$refs.search.resetValidation()
      }
      if (this.isLoggedIn && this.flag_sala && this.roleUser == 'enlace') {
          this.sala_id = this.currentUser.sala_data.id;
          this.flag_sala = false
          this.getTocasCount()
      }
      if (this.delito) {
        var nombre_delito = this.delito.nombre
      } else {
        var nombre_delito = ''
      }

      // Obtener token de reCAPTCHA v3 antes de buscar
      // NOTA: El reCAPTCHA ahora lo maneja el interceptor de axios automáticamente.
      // Si el backend responde 403 con require_recaptcha, el interceptor ejecuta
      // grecaptcha.execute() y reintenta el request sin que el usuario note nada.
      this.$store.dispatch("GET_TOCAS", { url:  "tocas?page=" + this.pagination.current,
        data: {
          tipo_fecha: this.tipo_fecha,
          fecha_ini: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          sala_id:this.sala_id,
          numero:this.numero,
          periodo:this.periodo,
          derivado:this.derivado,
          delito_id:this.delito_id,
          materia_id:this.materia_id,
          tipo_juicio_id:this.tipo_juicio_id,
          nombre_delito:nombre_delito,
          accion_especifica_id: this.accion_especifica_id,
          accion_simultanea_id:this.accion_simultanea_id,
          magistrado_id:this.magistrado_id,
          sentido_id:this.sentido_id,
          tipo_sentencia:this.tipo_sentencia,
          resolucion:this.resolucion,
          palabra_clave:this.palabra_clave,
          perspectiva_genero: this.perspectiva_genero === true ? 1 : '',
          principio_ninez: this.principio_ninez === true ? 1 : '',
          paginador: this.paginador
        }
        })
      .then((response) => {
        this.loadingTocas = false;
        this.pagination.current = response.data.data.tocas.current_page;
        this.pagination.total = response.data.data.tocas.last_page;
        this.per_page_table = response.data.data.tocas.per_page;
        this.TocasList = response.data.data.tocas.data;
        this.numero = '';
        this.periodo = '';
        this.totalSala = this.sala_id;
        // if(this.roleUser == 'superadmin' || this.roleUser == 'admin'){
          this.totalTocasAdmin = response.data.data.tocas.total
        // }
        this.$nextTick(() => {
          if (this.scrollToList) {
            this.scrollToList = false;
            var listTop = this.$el.getElementsByClassName('scroll-to-me')[0];
            if (listTop) {
              listTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        });
      })
      .catch(error => {
        this.scrollToList = false;
        this.loading = false;
        this.numero = '';
        this.periodo = '';
        this.number = '';
        console.log(error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ingresa un numero de toca válido',
          confirmButtonText: "Aceptar"
        })
      });

      this.$refs.search.resetValidation()
    },
    onPageChange() {
      // El scroll al inicio del listado se hace después de cargar los datos
      // (ver $nextTick en buscar()), porque el spinner cambia la altura
      // de la página y anularía un scroll hecho antes de la carga.
      this.scrollToList = true;
      this.buscar();
    },
    goToPage(page) {
      var total = this.pagination.total || 0;
      if (!page || page < 1 || page > total || page === this.pagination.current) return;
      this.pagination.current = page;
      this.onPageChange();
    },
    nextPage() {
      this.goToPage(this.pagination.current + 1);
    },
    prevPage() {
      this.goToPage(this.pagination.current - 1);
    },
    getFile(item, text){
      this.progress = true
      this.$store
        .dispatch("GET_FILE", { id: item.id, modo: text == 'visualizar' ? 'visualizar' : 'descargar' })
        .then((response) => {
          const res = Array.isArray(response) ? response[0] : response;
          const url = res.data.data.url;
          if (text == 'descargar') {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.id + '.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          if (text == 'visualizar') {
            this.pdfUrl = url;
            this.pdfLoaded = false;
            this.dialogPDF = true;
          }
          this.progress = false
        })
        .catch(err => {
          this.progress = false
          console.log('GET_FILE error:', err);
          this.$swal({
            title: 'Error al obtener la sentencia',
            icon: 'error',
            text: 'No se pudo acceder al documento. Intente nuevamente.'
          })
        });
    },
    descargarDesdePDF(){
      if (this.pdfUrl) {
        const link = document.createElement('a');
        link.href = this.pdfUrl;
        link.setAttribute('download', 'sentencia.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getFileTXT(item, text){
      this.progressFileTXT = true
      this.$store
        .dispatch("GET_FILE_TXT", item.id)
        .then((response) => {
          const res = Array.isArray(response) ? response[0] : response;
          const url = res.data.data.url;
          this.progressFileTXT = true;
          this.value = 0;
          const duration = 1000;
          const steps = 10;
          const intervalTime = duration / steps;

          this.interval = setInterval(() => {
            if (this.value >= 150) {
              clearInterval(this.interval);

              // Descargar el contenido TXT desde la URL pre-firmada
              fetch(url)
                .then(res => res.text())
                .then(textContent => {
                  this.fileContentTXT = textContent;
                  this.dialogFileTXT = true;
                  this.progressFileTXT = false;
                })
                .catch(err => {
                  this.progressFileTXT = false;
                  this.$swal({
                    title: 'Error al cargar el resumen',
                    icon: 'error',
                    text: 'No se pudo acceder al resumen ciudadano.'
                  })
                  console.log(err);
                });

              this.value = 0;
            } else {
              this.value += 100 / steps;
            }
          }, intervalTime);
        })
        .catch(err => {
          this.progressFileTXT = false;
          this.$swal({
            title: 'Error al obtener el resumen',
            icon: 'error',
            text: 'No se pudo acceder al resumen ciudadano.'
          })
          console.log(err);
        });
    },
    editSentencia(item){
      if (this.$refs.form.validate()) {
        if (this.editedItem.magistrado_id =="" || this.editedItem.numero==""  || this.editedItem.periodo=="" || this.editedItem.fecha_publicacion=="" || this.editedItem.fecha_emision=="") {
          Swal.fire({
            icon: 'warning',
            title: 'Verifica los campos obligatorios',
            showConfirmButton: false,
            timer: 2000
          })
        } else {
          this.loading = true
            // console.log(item);
          // item.fecha_emision = this.editedItem.fecha_emision + ' '+this.hora_emision
          // item.fecha_publicacion = this.editedItem.fecha_publicacion + ' '+this.hora_publicacion
          this.$store.dispatch("EDIT_TOCA", {
            url: "/toca/"+item.id,
            data : item
          })
          .then((response) => {
            // console.log(response);
            if (response.data.status == 'ok') {
                Swal.fire({
                  icon: 'success',
                  title: 'Sentencia Actualizada',
                  showConfirmButton: false,
                  timer: 1500
                })
              this.close();
              this.progress = false
              this.loading = false
              this.buscar()
              if (this.roleUser == 'enlace') {
                this.getTocasCount()
              }
            }
          })
          .catch(err => {
            if (err.response && err.response.status === 401) return;
            let mensaje = 'Ocurrió un error al actualizar la sentencia.';
            if (err.response && err.response.data && err.response.data.message) {
              mensaje = err.response.data.message;
            } else if (err.response && err.response.status === 429) {
              mensaje = 'Demasiadas solicitudes. Espere un momento e intente de nuevo.';
            }
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: mensaje,
              showConfirmButton: true,
            })
            this.progress = false
            this.loading = false
          });
        }
      }
    },
    saveSentencia() {
      if(this.editedItem.sala_id=="" && this.roleUser == 'enlace') {
        this.editedItem.sala_id = this.currentUser.sala_data.id
        this.editedItem.magistrado_id = this.currentUser.magistrado_data.id
      }
      if((this.editedItem.magistrado_id =="" && !this.check_magistrado) || this.editedItem.numero==""  || this.editedItem.periodo=="" || this.editedItem.fecha_publicacion=="" || this.file=="" || this.editedItem.fecha_emision==""){
        Swal.fire({
          icon: 'warning',
          title: 'Verifica los campos obligatorios',
          showConfirmButton: false,
          timer: 2000
        })
      } else {
        if (this.$refs.form.validate()) {
          this.FilesToUpload();
          this.progress = true
          this.loading = true
          // this.hora_publicacion = new Date().toLocaleTimeString()

          var data = this.editedItem
          data.file = this.archivo
          // date and time are concatenated to "fecha_publicacion"
          // var fecha_publicacion = this.editedItem.fecha_publicacion + ' ' + this.hora_publicacion
          // data.fecha_publicacion = this.$moment(fecha_publicacion).format('YYYY-MM-DD HH:mm:ss'); // convert time to 24-hour format.
          // date and time are concatenated to "fecha_emision"
          // var fecha_emision = this.editedItem.fecha_emision + ' ' + this.hora_publicacion
          // data.fecha_emision = this.$moment(fecha_emision).format('YYYY-MM-DD HH:mm:ss'); // convert time to 24-hour format.

          this.$store.dispatch("SAVE_TOCA", {
            url: "/toca",
            data : data
          })
          .then((response) => {
            //console.log(response);
            if (response.data.status == 'ok') {
                Swal.fire({
                  icon: 'success',
                  title: 'Sentencia Guardada',
                  showConfirmButton: false,
                  timer: 1500
                })
              this.close();
              this.progress = false
              this.loading = false
              this.buscar()
              if (this.roleUser == 'enlace') {
                this.getTocasCount()
              }
            }
          })
          .catch(err => {
            if (err.response && err.response.status === 401) return;
            let mensaje = 'Ocurrió un error al guardar la sentencia.';
            if (err.response && err.response.data && err.response.data.message) {
              mensaje = err.response.data.message;
            } else if (err.response && err.response.status === 429) {
              mensaje = 'Demasiadas solicitudes. Espere un momento e intente de nuevo.';
            }
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: mensaje,
              showConfirmButton: true,
            })
            this.progress = false
            this.loading = false
          });
        }
      }
    },
    fileSelected(){
      var file = this.file[0];
      this.getBase64(file).then(data => {
        this.files.push(data);
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        }
      });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    FilesToUpload() {
      if (this.files.length) {
        this.files.forEach(file => {
          var block = file.split(";");
          // Get the content type of the image
          var contentType = block[0].split(":")[1]; // In this case "jpg
          // get the real base64 content of the file
          // this.archivo['type'] = contentType
          var realData = block[1].split(",")[1];
          //console.log(realData);
          this.archivo['encode'] = realData
          // this.archivo['file_name'] = this.file[0].name
        });
      }
    },
    deleteSentencia(item){
      var sentencia = item.numero + '-' + item.periodo
      if (item.derivado) {
        sentencia = sentencia + '-' + item.derivado
      }
      this.$swal({
        title: '¿Eliminar Sentencia ' + sentencia +'?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_SENTENCIA",  { url: "/toca/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Sentencia eliminada correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.buscar()
            if(this.roleUser == 'enlace'){
              this.getTocasCount()
            }
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },
    close() {
      this.$refs.form.resetValidation()
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.dialog = false
      this.check_magistrado = false
      this.hora_publicacion = ''
      this.hora_emision = ''
      this.file = []
      if (this.roleUser != 'enlace') {
        this.materiasList = []
      }
    },
    copyURL(item) {
      this.dialogCopy = true
      const el = document.createElement('textarea');
      el.value = 'https://publicacionsentencias.stjjalisco.gob.mx/getfile/' + item.id;
      el.setAttribute('readonly', '');
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      var that = this;
      setTimeout(function () {
        that.dialogCopy = false
      }, 800);
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    saveVisita() {
    var visit = this.getCookie("visit");
      // console.log(visit);
      if(!visit){
        document.cookie = "visit=true;max-age=86400";
        var data = this.visita
        } else {
          var data = {visita: false}
        }
        this.$store.dispatch("SAVE_VISITA", {
          url: "/visita",
          data : data
        })
        .then((response) => {
          this.visitaCount = response.data.data.visitas.toLocaleString()
        })
        .catch(() => {
          // Silencioso — la visita es un contador interno
        });

    },
  }
}
</script>

<style scoped>
/* estilo para el contenido del modal de los archivos TXT */
  .text-container {
    overflow-y: auto; 
    font-family: monospace; 
    white-space: pre-wrap; 
    background: #f4f4f4; 
    padding: 16px; 
    border-radius: 4px; 
  }
  .full-screen-card {
    display: flex;
    flex-direction: column;
  }
  .full-screen-content {
    flex: 1;
    overflow-y: auto; 
    font-family: monospace;
    white-space: pre-wrap;
    background: #f4f4f4;
    padding: 16px;
  }
  .visita-count {
    color:#1A237E; 
    font-size: 17px !important;
  }
  .consulta-sentencias {
    color:gray; 
    font-size: 17px !important;
  }
  .icon-size {font-size: 1.4rem;}
  .parrafo {
    color: #000000;
    font-size: 15px;
    text-align: justify;
    font-family: inherit;
    font-weight: normal;
    line-height: 1.6;
    margin-bottom: 17px;
  }
  .truncate {
    max-width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .select-text {
    font-size: 13px;
    font-weight: 500;
  }
  .text-genero /deep/ label {
    color: purple;
    font-weight: bold;
  }
  .text-ninez /deep/ label {
    color: #2096F3;
    font-weight: bold;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .watermark-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: initial;
    background-origin: content-box;
    /* filter: blur(8px);
    -webkit-filter: blur(8px); */
    /* background-color: rgba(255, 255, 255, 0.9); */
    opacity: 0.1;
    z-index: 1;
  }
  .content-container {
    position: relative;
    z-index: 2; /* Keep content above the background */
  }
  .watermark-background img {
    pointer-events: none; /* Prevent interaction with the background */
  }
  /* ------------------------ TABLA TOCAS ------------------------ */
  tbody tr:nth-child(odd) {
    /* color: rgb(69, 69, 69);  
    background-color: rgb(242, 242, 242); */
    background-color: #72727228;
    color: #000000;
    font-weight: normal;
  }
  tbody tr:nth-child(even) {
    background-color: transparent;
    /* color: rgb(69, 69, 69); */
    color: #292929;
    font-weight: 400;
  }
  /* .v-data-table {
    background-color: transparent;
    height: 90vh !important;
    overflow-x: hidden;
  } */
  .v-simple-table tbody tr:hover {
    background-color: unset!important;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > 
  table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
    border-bottom: unset!important;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > 
  table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):nth-child(even)
  {
    /* background-color: rgb(230, 230, 230);
    color: rgb(55, 55, 55); */
    background-color: transparent!important;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > 
  table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):nth-child(odd)
  {
    /* background-color: rgb(230, 230, 230); 
    color: rgb(55, 55, 55); */
    background-color:#72727228!important;
    /* background-color:initial!important; */
  }
</style>
